
import { h, Fragment, render } from 'preact'
import { useEffect, useState, useRef } from 'preact/hooks'
import { createPortal } from 'preact/compat'
import { initialSessionFromDom, useSubmission } from './../hooks/useSubmission'

import { json } from './../utility/dom'
import { scrollTo } from './../utility/scrollTo'

import { SubmitButton } from './../components/SubmitButton'
import { ExpiryCounter } from './../components/ExpiryCounter'


export function init() {
	const reviewEl = document.getElementById('register-review-form')
	const errorEl = document.getElementById('register-review-errors')
	const session = initialSessionFromDom()
	const stages = json('#form-stages')
	reviewEl && render(
		createPortal(<ReviewForm session={session} stages={stages} errorEl={errorEl} />, reviewEl), 
		document.body
	)
}

function ReviewForm({ session, stages, errorEl }) {

	const beforeSubmit = data => ({ ...data, Stage: 'complete' })
	const onSuccess = () => window.location = stages.success
	const onError = () => {
		setTimeout(() => {
			const el = document.querySelector('[class*="error"]')
			el && scrollTo(el, -80)
		}, 20)
	}
	
	const { 
		expires, processing, submitted, validation,
		onSubmitComplete, extendSession,
	} = useSubmission({ session, beforeSubmit, onSuccess, onError })


	const errorTitle = validation?.invenias?.message || 'Could not process registration'
	const errorMessage = {
		'uploadFile': 'There was a problem uploading your documents. Please try again or contact support if the problem persists.'
	}[validation?.invenias?.errorState?.name] || ''

	return <>
		<form onSubmit={onSubmitComplete}>
			{errorEl && createPortal(<>
				{validation?.invenias && <div class="message-box error">
    				{validation.invenias.message || 'Could not process registration'}{errorMessage && ':'}<br />
    				<strong>{errorMessage}</strong>
    			</div>}
			</>, errorEl)}
			<SubmitButton class="button button--fill button--yellow" processing={processing || submitted}>
				{(processing || submitted) && 'Processing' || 'Complete'}
			</SubmitButton>
			<ExpiryCounter expires={expires} onExtend={extendSession} />
		</form>
	</>
}












